<template>
  <div class="container">
    <div class="uploaderForm">
      <van-cell-group class="group">
        <van-field label="用户名" :value="list.userName" readonly />
        <van-field label="姓名" :value="list.name" readonly />
        <van-field label="手机号" :value="list.phoneNumber" readonly />
        <!-- <van-field label="身份证号" :value="list.idCard" readonly /> -->
        <!-- <van-field label="出生日期" :value="list.birthDay" readonly />
        <van-field label="性别" :value="getChineseStatus(list.gender)" readonly /> -->
        <!-- <van-field name="uploader" label="身份证照片" class="IdCard">
          <template #input>
            <div class="myCard">
              <div v-for="item in list.pictures" :key="item.picturesId" class="itemID">
                <van-image :src="item.pictureUrl" />
              </div>
            </div>
          </template>
        </van-field> -->
      </van-cell-group>
    </div>
    <div class="bottom">
      <button class="bottomBtn" @click="onConfirm(list.employeeId)">通过</button>
      <button class="bottomBtn noBtn" @click="onClick(list.employeeId)">不通过</button>
    </div>
  </div>
</template>
<script>
import {
  CellGroup,
  Uploader,
  Toast,
  Dialog,
  Field,
  Icon,
  Image as VanImage
} from "vant";
import service from "../../api/userCenterPage/userCenterPage";
import serviceEmploye from "../../api/employeePage/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [VanImage.name]: VanImage
  },
  data() {
    return {
      status: "true",
      list: {},
      fileList: []
    };
  },
  mounted() {
    this.init(this.$route.query.id);
  },
  methods: {
    init(id) {
      service.detail(id).then(res => {
        this.list = res.data;
      });
    },
    // getChineseStatus(status) {
    //   switch (status) {
    //     case 0:
    //       return "男";
    //     case 1:
    //       return "女";

    //     default:
    //       break;
    //   }
    // },
    onConfirm(id) {
      serviceEmploye
        .agreed(id)
        .then(res => {
          if (res.statusCode == 200) {
            Toast("店长已同意");
            this.$router.go(-1);
          }else{
            Toast(res.errors)
          }
        })
        .catch(err => {
          // Toast(err.data);
        });
    },
    onClick(id) {
      serviceEmploye
        .disagreed(id)
        .then(res => {
          if (res.statusCode == 200) {
            Toast("店长已拒绝");
            this.$router.go(-1);
          }else{
            Toast(res.errors)
          }
        })
        .catch(err => {
          // Toast(err.data);
        });
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.container {
  height: calc(100% - 46px);
  display: flex;
  flex-direction: column;
  overflow: auto;
  .uploaderForm {
    flex: 1;
  }
  .van-cell {
    font-size: 4vw;
    padding: 0 6vw;
    line-height: 14.4vw;
    @{deep}.van-field__label {
      width: 78px;
      margin-right: 2vw;
      color: #000;
    }
    @{deep}.van-field__control {
      color: #919191;
      font-size: 3.6vw;
    }
  }
  .IdCard {
    padding: 2vw 4vw 2vw 6vw;
    .itemID {
      width: 31vw;
      height: 20vw;
      margin-right: 1.5vw;
      margin-bottom: 2vw;
    }
  }
  .myCard {
    display: flex;
    flex-wrap: wrap;
  }
  .group {
    box-shadow: 0px 18px 23px 1px rgba(0, 0, 0, 0.03);
  }

  .bottom {
    width: 100%;
    height: 48vw;
    display: flex;
    justify-content: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .bottomBtn {
      width: 80vw;
      height: 12vw;
      margin-top: 2vw;
      border: 0;
      border-radius: 1.33vw;
      color: #fff;
      font-size: 4vw;
      background: linear-gradient(0deg, #ee0a24, #f5586b);
    }
    .noBtn {
      background: #f8f8f8;
      color: #8b8b8b;
    }
  }

  .group {
    box-shadow: 0px 18px 23px 1px rgba(0, 0, 0, 0.03);
  }
}
</style>